import { Injectable } from '@angular/core';
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { catchError, mergeMap, Observable, throwError } from 'rxjs';
import { RfJwtService } from './rf-jwt.service';
import { AuthService } from './auth.service';
import { RfHttpInterceptorInterceptor } from '../rf-http-interceptor.interceptor';
import { EchoService } from './echo.service';

@Injectable()
export class RFRefreshInterceptorInterceptor implements HttpInterceptor {
    constructor(
        private echoService: EchoService,
        private authService: AuthService,
        private jwtInterceptor: RfHttpInterceptorInterceptor,
    ) {}

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler,
    ): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((err) => {
                const errorResponse = err as HttpErrorResponse;
                // `error` is null when the 401 has no JSON body -- POST /login
                // answers a wrong password with one. Reading `.msg` off it threw
                // a TypeError that replaced the 401, so the login page could
                // not tell a wrong password from an outage.
                if (
                    errorResponse.status === 401 &&
                    errorResponse.error?.msg === 'Jwt Expired'
                ) {
                    RfJwtService.clear();
                    return this.authService.refresh().pipe(
                        mergeMap(() => {
                            // Re-key only a connection a portal opened: the
                            // ones that use Echo call setupEcho() on entry, and
                            // the rest must not get one on refresh (RF-3045).
                            if (this.echoService.hasConnection()) {
                                this.echoService.setupEcho();
                            }
                            return this.jwtInterceptor.intercept(request, next);
                        }),
                    );
                }
                return throwError(err);
            }),
        );
    }
}
